export default __webpack_public_path__ + "static/media/fig1.37a239a7.jpg";